"use client";

import { useState, type ReactNode } from "react";
import { Container } from "@/components/ui/container";

const ACCENT = "#2BA6E6";

/**
 * Category chips for the blog index. Every post card is server-rendered and
 * passed in as children; selecting a chip only flips a `data-active` attribute
 * that the accompanying stylesheet uses to hide non-matching cards.
 */
export function BlogCategoryFilter({
  categories,
  children,
}: {
  categories: string[];
  children: ReactNode;
}) {
  const [activeCategory, setActiveCategory] = useState("All");

  return (
    <>
      <section className="py-6 bg-white border-b border-neutral-100 sticky top-20 z-30">
        <Container>
          <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setActiveCategory(cat)}
                className="flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200"
                style={
                  activeCategory === cat
                    ? { backgroundColor: ACCENT, color: "#fff", boxShadow: "0 2px 8px rgba(43,166,230,0.35)" }
                    : { backgroundColor: "#f3f4f6", color: "#374151" }
                }
              >
                {cat}
              </button>
            ))}
          </div>
        </Container>
      </section>

      <div data-blog-results="" data-active={activeCategory}>
        {children}
      </div>
    </>
  );
}
